import { render, staticRenderFns } from "./InsurancesDetails.vue?vue&type=template&id=cb0761cc"
import script from "./InsurancesDetails.vue?vue&type=script&lang=js"
export * from "./InsurancesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports